"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var AlertHTML = function AlertHTML(state) {
  return (0, _preact.h)("div", {
    role: "alert",
    className: "alert alert-".concat(state.type),
    style: !state.isVisible ? {
      display: 'none'
    } : undefined
  }, state.message);
};

var AlertComponent = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(AlertComponent, _Component);

  var _super = _createSuper(AlertComponent);

  function AlertComponent(props) {
    var _this;

    (0, _classCallCheck2.default)(this, AlertComponent);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "timeout", void 0);
    _this.timeout = 0;
    _this.state = {
      isVisible: false,
      message: '',
      type: '',
      isVisibleFor: props.isVisibleFor ? props.isVisibleFor : 3000
    };
    return _this;
  }

  (0, _createClass2.default)(AlertComponent, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this2 = this;

      if (this.state.isVisible) {
        clearTimeout(this.timeout);
        this.timeout = window.setTimeout(function () {
          return _this2.setState({
            isVisible: false
          });
        }, this.state.isVisibleFor);
      }
    }
  }, {
    key: "success",
    value: function success(message) {
      this.setState({
        isVisible: true,
        message: message || 'Changes applied successfully!',
        type: 'success'
      });
    }
  }, {
    key: "error",
    value: function error(message) {
      this.setState({
        isVisible: true,
        message: message || 'Changes could not be applied',
        type: 'danger'
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var props = this.props;
      var state = this.state;
      var Component = props.component;
      return (0, _preact.h)(Component, (0, _extends2.default)({}, props, {
        successCallback: function successCallback(e) {
          return _this3.success(e);
        },
        errorCallback: function errorCallback(e) {
          return _this3.error(e);
        },
        alertComponent: (0, _preact.h)(AlertHTML, state)
      }));
    }
  }]);
  return AlertComponent;
}(_preact.Component);

var _default = AlertComponent;
exports.default = _default;